import { Controller } from "stimulus";
import debounce from 'lodash.debounce';
import Cookies from 'js-cookie';
import {getState, setState} from '../search_results/state'
import Filter from '../filter'
import {saveSearch, renameSearch} from '../helpers/search_helpers'

export default class extends Controller {
  // Set this when the user enters the textbox.  Clear it when done
  previousSearchName = ""

  connect() {
    // NOT SURE IF THIS IS THE RIGHT WAY TO HANDLE THE RESIZE
    window.addEventListener('resize', debounce(this.windowResize,500))
    window.addEventListener("beforeunload", function () {
      sessionStorage.removeItem("highlightedListingId");
    });
    //window.addEventListener('popstate', this.handlePopState)

    // Make this check before calling other things so we can redirect faster if that
    // is what we are going to do.
    let currentURL = new URL(window.location.href);
    let windowState = window.history.state;

    var filterable = this.data.get('is-filterable');
    var isReactNativeFilterScreenEnabled = window?.nativeAppInterface?.isReactNativeFilterScreenEnabled() ?? false;
    
    if(filterable === 'true'){
       if(isReactNativeFilterScreenEnabled){
        const filter = getState('filter');

        /**
         * Open the Android App's Filter Panel
         * */
        const filterString = filter.toString();
        /**
         * We explicitly want these to be undefined and not null if there is no value
         */
        const quickSearchId = this.data.get('quicksearch-id') ?? undefined;
        const savedSearchId = this.data.get('savedsearch-id') ?? undefined;
        const shapes = filter.shapes();

        window.searchResultsData = {
          filterString,
          quickSearchId,
          savedSearchId,
          shapes
        };
   
         /*
          Hide the existing filter panel
        */
        document.querySelector('.c-menubar--left')?.classList?.toggle('open');
        document.querySelector('.sub-nav__toggle--left')?.classList?.toggle('active');

        window.nativeAppInterface.displayFilterScreen({ filterString, quickSearchId, savedSearchId, shapes });
      }
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.debounceResize)
    window.removeEventListener("beforeunload")
    //window.removeEventListener('popstate', this.handlePopState)
  }

  updateCount(data) {
    if (data.detail !== null && typeof data.detail.message !== 'undefined') {
      $('.totalCount').html(data.detail.count);
    }
  }

  filterChanged(data) {
    console.log("FILTER CHANGED DATA: ", data)
  }

  windowResize() {
    console.log("WINDOW RESIZED!")
  }

  filterFormReloaded(data) {
    let count = data.detail.count
    let newExpressions = data.detail.expressions

    setState('listingCountTotal', count)

    let newFilter = new Filter(newExpressions, mapSupport.locationFields)

    let oldExpressions = getState('filter').expressions()

    var added = new Filter(Filter.expressionsAdded(oldExpressions, newExpressions), mapSupport.locationFields)
    var removed = new Filter(Filter.expressionsRemoved(oldExpressions, newExpressions), mapSupport.locationFields)

    // If there is one shape still here, they are all still here.  Only delete annotations if there are no shapes.
    var deleteAnnotations = true;
    newExpressions.forEach( function(expression) {
      if (expression.type == 'shape') {
        deleteAnnotations = true;
      }
    })
    if (deleteAnnotations) {
      setState('annotations',[])
    }

    // TODO: In search_results.js, there is a lot more that goes on before setting the filter state.
    // Still need to figure out how much of that we need to do.
    setState('filter',newFilter)
  }

  changingSearchName(evt) {
    // The user has entered the text box
    this.previousSearchName = evt.currentTarget.value
  }

  async searchNameChanged(evt) {
    // The user left the text box
    let $searchNameEle = $(evt.currentTarget)
    if ($searchNameEle.val() === '') {
      if (this.previousSearchName === '') {
        // The user didnt add any text to the previously empty textbox
        $searchNameEle.removeClass('value-added');
        return;
      }
      // The user left an empty text box.  Restore the previous content
      $searchNameEle.val(this.previousSearchName);
      this.previousSearchName = ''
      return;
    } else if ($searchNameEle.val() === this.previousSearchName) {
      // The user didnt change the text
      return;
    }

    if ($searchNameEle.hasClass('value-added')) {
      // Something was here before.  We must just be changing the name.
      let success = await renameSearch($searchNameEle.val())
      if (!success) {
        // Didnt work!  Change the name back to what it was.
        $searchNameEle.val(this.previousSearchName)
      }
      this.previousSearchName = ''
      return;
    }

    // We are creating a named search.  We can only do this with a quick search or a comparable search.
    var regex = /(?<=\/quick_searches\/)\d{26}/;
    // Extract the 26-digit number using the regular expression
    var match = window.location.href.match(regex);
    let quicksearch_id = null;
    if (match) {
      // Extracted 26-digit number
      quicksearch_id = match[0];
    } else if (window.location.href.indexOf('search/comparables_search/search_results')) {
      // TODO:  Do we want to add saving capability for saving address or mls_number searches?

      // We are a flexpanel route comparable search.  We want to save this search.
      match = true;
    }

    if (!match) {
      toast.error('Unable to create a saved search from this search type.');
      return;
    }

    let filter = getState('filter').toString();
    let annotations = getState('annotations');
    saveSearch(filter, annotations, quicksearch_id, $searchNameEle.val(), this.previousSearchName )
  }

  /*
  handlePopState(event) {
    const state = history.state;
    if (state) {
      if (state.turbo) {
        console.log("Got a pop state event and it seems as if we need to ignore this turbo state")
        console.log("My session state: ", JSON.parse(sessionStorage.getItem('listingsSpaHistory')));
        return;
      }
      if (state.itemUrl.length > 0) {
        // We have a frame to load.  But don't push do pushState because this load
        // is a result of the previous state going back to here.
        console.log("We have a frame to load.  But don't push do pushState because this load is a result of the previous state going back to here", state)
        //loadLDPTurboFrame(state.itemUrl, false)
      } else {
        // No item to show.  Hide the turbo-frame
        console.log("No item to show.  So we need to do anything else?", state)
        //$('#content-turbo-frame').addClass('hidden');
      }
    } else {
      // We are at the main results page and we just need to make sure there are no
      // listings displayed.
      console.log("We are back at our main page.  Make sure the overlay is hidden????")
      //$('.displayed-in-ldp').removeClass('displayed-in-ldp');
      //$('#content-turbo-frame').addClass('hidden');
    }
  }
  */

  listingCountTotalChanged(data) {
    // Update any header informatin that has the count
    $('.search-results-count .totalCount').text(data.detail.newValue);
  }

}
